export enum PremiumCheckListEnum {
    MODULE_ACCESS = 'View',
    EMERGENCY_AUTHORIZATION_ACCESS = 'NA',
    PTA_APPROVE_ACCESS = 'PTA_Request_Approve',
    PTA_REJECT_ACCESS = 'PTA-Request_Reject',
    EVENTLOG_VIEW_ACCESS = 'PTA_Request_ViewEventLogs',
    DOWNLOAD_PDF_ACCESS = 'PTA_Request_DownloadPDF',
    PTA_RETRIGGEREMAIL_ACCESS = 'NA',
}
